import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TransportReportView from "../../components/midpoint/transport/reports/TransportReportView";
import { exportTransportReport, fetchTransportReport } from "../../api/transportReportsApi";

const TransportReportDetailPage = () => {
  const { reportKey } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [exportMessage, setExportMessage] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchTransportReport(reportKey)
      .then((body) => {
        if (!cancelled) setReport(body.report);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Unable to load report.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [reportKey]);

  const handleExport = async (exportType) => {
    setExportMessage("");
    try {
      const result = await exportTransportReport(reportKey, exportType);
      const url = URL.createObjectURL(result.blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = result.filename;
      anchor.click();
      URL.revokeObjectURL(url);
      setExportMessage(`Exported ${result.filename}`);
    } catch (err) {
      setExportMessage(err.message || "Export failed.");
    }
  };

  if (loading) {
    return (
      <div className="crm-experience__inner">
        <p className="muted">Loading report…</p>
      </div>
    );
  }

  if (error || !report) {
    return (
      <div className="crm-experience__inner">
        <p className="error-text">{error || "Report not found."}</p>
        <Link to="/reports/transport">Back to reports</Link>
      </div>
    );
  }

  return (
    <div className="crm-experience__inner">
      <div className="crm-actions" style={{ marginBottom: "1rem" }}>
        <Link to="/reports/transport" className="crm-btn crm-btn-secondary">
          Back to reports
        </Link>
        <button type="button" className="crm-btn crm-btn-secondary" onClick={() => handleExport("json")}>
          Export JSON
        </button>
        <button type="button" className="crm-btn crm-btn-secondary" onClick={() => handleExport("csv")}>
          Export CSV
        </button>
        <button type="button" className="crm-btn crm-btn-secondary" onClick={() => handleExport("html")}>
          Export HTML
        </button>
      </div>
      {exportMessage ? <p className="muted">{exportMessage}</p> : null}
      <TransportReportView report={report} />
    </div>
  );
};

export default TransportReportDetailPage;
